import { render, staticRenderFns } from "./FbLogin.vue?vue&type=template&id=bf46f5b8"
import script from "./FbLogin.vue?vue&type=script&lang=js"
export * from "./FbLogin.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports